import { SET_SATSER, SetSatserAction } from './Types';
import { StamdataNordenHelgradModel } from '../../Models/StamdataNordenHelgradModel';

export function setSatser(satser: StamdataNordenHelgradModel): SetSatserAction {
    return {
        type: SET_SATSER,
        payload: satser,
    };
}